if (!customElements.get('vbb-accordion')) {
  customElements.define('vbb-accordion', class Accordion extends HTMLElement {
    constructor() {
      super();

      // Selectors
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.accordion__content');

      // State
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;

      // Event Listener
      this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
      e.preventDefault();
      this.details.style.overflow = 'hidden';
      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }

    shrink() {
      this.isClosing = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 100,
        easing: 'ease-out'
      });

      this.animation.onfinish = () => this.onAnimationFinish(false);
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.isExpanding = true;
      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      if (this.animation) {
        this.animation.cancel();
      }

      this.animation = this.details.animate({
        height: [startHeight, endHeight]
      }, {
        duration: 200,
        easing: 'linear'
      });

      this.animation.onfinish = () => this.onAnimationFinish(true);
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      this.details.open = open;
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.details.style.height = this.details.style.overflow = '';
    }
  });
}

if (!customElements.get('vbb-accordion-nav')) {
  customElements.define('vbb-accordion-nav', class AccordionNav extends customElements.get('vbb-accordion') {
    constructor() {
      super();
    }

    onClick(e) {
      console.log('AccordionNav clicked');
      this.closeOtherAccordions();
    }

    closeOtherAccordions() {
      document.querySelectorAll('vbb-accordion-nav details[open]').forEach(openDetails => {
        if (openDetails !== this.details && !this.details.contains(openDetails) && !openDetails.contains(this.details)) {
          openDetails.open = false;
        }
      });
    }
  });
}
